/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Receving extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Receving;


// WEBPACK FOOTER //
// ./src/routes/receiving/index.js